export const USG_GET_REGINFO = "login/stateRegisterInfo";

// Actions
export const USG_ACTION_LOGIN = "login/stateLoginAction";
export const USG_ACTION_USER_UPDATE = "login/stateUpdateUser";
export const USG_ACTION_SESSION = "login/stateSessionAction";
export const USG_ACTION_REGISTER = "login/stateRegisterAction";
export const USG_ACTION_LOGOUT = "login/stateLoginReset";
export const USG_ACTION_ACTIVATE = "login/stateActivate";
export const USG_ACTION_RECOVER = "login/stateRecover";
export const USG_ACTION_RESET = "login/stateReset";
export const USG_ACTION_SET_ROLE = "login/stateSetRole";



// WEBPACK FOOTER //
// ./src/store/types_login.js